import * as React from 'react';
import { lazyInject } from '../../../services/inversify';
import { ApiService } from '../../../services/api_service';
import { DataService } from '../../../services/data_service';
import { IDs } from '../../../helpers/IDs';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';
import { getDefaultHelpIcon } from '../../../helpers/getDefaultHelpIcon';

interface AuswahlErfassungsmodusProps extends React.ClassAttributes<any> {
    data: any;
    erfassungsmodus?: string;
    layout?: string;
    onWillChange?: () => void;
    onChange?: (erfassungsmodus: string) => void;
}

interface AuswahlErfassungsmodusState {
    loading: boolean;
    enableSelect: boolean;
    erfassungsmodus: string;
}

export class AuswahlErfassungsmodus extends React.Component<AuswahlErfassungsmodusProps, AuswahlErfassungsmodusState> {

    constructor(props: any) {
        super(props);
        this.state = {
            loading: false,
            enableSelect: true,
            erfassungsmodus: 'simple'
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.setStateErfassungsmodus();
    }

    componentDidUpdate(prevProps: any, prevState: any): void {
        if (prevProps.erfassungsmodus !== this.props.erfassungsmodus) {
            this.setStateErfassungsmodus();
        }
    }

    setStateErfassungsmodus() {
        const modul: string = (this.props.data || {}).MODUL_SELECTED || null;
        let erfassungsmodus, enableSelect;
        if (
            // ['cfm', 'classic'].indexOf(modul) !== -1 || this.apiService.getBereichKey() === 'kultur'
            // WKETOOL-258: Soll diese Auswahl im Redesign immer ausgeblendet werden?
            true
        ) {
            erfassungsmodus = 'ghg';
            enableSelect = false;
            this.updateErfassungsmodus('ghg');
        } else {
            const config = this.props.data[IDs.ENT_KONFIGURATION][0];
            erfassungsmodus = config.co2_fussabdruck_modus;
            enableSelect = true;
        }
        this.setState({ erfassungsmodus, enableSelect });
    }

    updateErfassungsmodus(modus: string) {
        const { data, onChange } = this.props;
        const config = data[IDs.ENT_KONFIGURATION][0];
        if (config.co2_fussabdruck_modus !== modus) {
            config.co2_fussabdruck_modus = modus;
            this.setState({ loading: true }, () => {
                this.dataService.setData(IDs.MOD_ETOOL, IDs.ENT_KONFIGURATION, { tid: config.tid, co2_fussabdruck_modus: modus },
                    () => this.triggerService.fire('reload', IDs.ENT_KONFIGURATION, () => {
                        this.setState({ loading: false });
                        if (onChange) {
                            onChange(modus);
                        }
                    }));
            });
        }
    }

    render() {
        const { loading, enableSelect } = this.state;
        return <div>
            {loading && <WSpinner />}
            {enableSelect && this.renderErfassungsmodus()}
        </div>;
    }

    renderErfassungsmodus() {
        const { onWillChange, layout } = this.props;
        return <div
            key={'auswahl_erfassungsmodus'}
            style={{ display: 'flex', alignItems: 'center', }}
        >
            <select
                value={this.state.erfassungsmodus}
                onChange={(evt: any) => {
                    const erfassungsmodus = evt.target.value;
                    if (onWillChange) {
                        onWillChange();
                    }
                    this.setState({ erfassungsmodus }, () => this.updateErfassungsmodus(erfassungsmodus));
                }}
            >
                <option value='simple'>Kompakte Erfassung</option>
                <option value='ghg'>Detaillierte Erfassung</option>
            </select>&nbsp;
            {getDefaultHelpIcon('energie_form_erfassungsmodus', 'Erfassungsmodus', this.props.data, null,
                { ...(layout === 'sidebysideComplexGreen' ? { backgroundColor: 'rgb(0, 176, 80)' } : {}) },
                { position: 'unset', marginTop: 0, marginLeft: 10 })}
        </div>;
    }
}
